"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const jwtDecode = require("jwt-decode");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
exports.fetchUser = () => (dispatch) => {
    const token = Environment_1.getJudoToken() || Environment_1.getToken();
    if (!token && !Environment_1.isRunningInIframe()) {
        window.location.replace('/auth/sign-in');
    }
    let jwtDecoded;
    try {
        jwtDecoded = jwtDecode(token);
    }
    catch (_a) {
        if (!Environment_1.isRunningInIframe()) {
            window.location.replace('/auth/sign-in');
        }
    }
    const userId = jwtDecoded.sub;
    const query = graphql_tag_1.default `
            query user($id: ID!) {
                user(id: $id) {
                    name
                    email
                    permissionScopes
                    account {
                        id
                        name
                        platformFeatures
                        platformVersion
                        settings {
                            campaigns {
                                deviceListKeyPath
                                deviceListKeyPaths
                                ticketingFeatureEnabled
                            }
                        }
                    }
                }
            }
        `;
    const request = {
        query,
        variables: {
            id: userId,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_USER_FAILURE', dispatch, errors[0].message);
        }
        else {
            const { user } = data;
            const { name, email, permissionScopes, account } = user;
            if (!account.platformFeatures.includes('campaigns')) {
                location.replace('/experiences/');
            }
            return dispatch({
                type: 'FETCH_USER_SUCCESS',
                user: {
                    userName: name,
                    userEmail: email,
                    permissionScopes: permissionScopes,
                    accountName: account.name,
                    platformVersion: account.platformVersion,
                    settings: {
                        keyPath: account.settings.campaigns.deviceListKeyPath,
                        keyPaths: account.settings.campaigns.deviceListKeyPaths,
                        ticketingFeatureEnabled: account.settings.campaigns.ticketingFeatureEnabled,
                    },
                },
            });
        }
    }, ({ result }) => {
        handleError_1.default('FETCH_USER_FAILURE', dispatch, result.errors[0].message);
    });
};
